var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50083 13.2871V13.0681C1.53295 12.4202 1.7406 11.7925 2.10236 11.2496C2.7045 10.5975 3.1167 9.79831 3.29571 8.93598C3.29571 8.2695 3.29571 7.5935 3.35393 6.92703C3.65469 3.71842 6.82728 1.5 9.96106 1.5H10.0387C13.1725 1.5 16.345 3.71842 16.6555 6.92703C16.7137 7.5935 16.6555 8.2695 16.704 8.93598C16.8854 9.8003 17.2972 10.6019 17.8974 11.2591C18.2618 11.7972 18.4698 12.4227 18.4989 13.0681V13.2776C18.5206 14.148 18.2208 14.9968 17.6548 15.6674C16.907 16.4515 15.8921 16.9393 14.8024 17.0384C11.607 17.3812 8.38303 17.3812 5.18762 17.0384C4.09914 16.935 3.08576 16.4479 2.33521 15.6674C1.778 14.9963 1.48224 14.1526 1.50083 13.2871Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55469 20.3516C8.05396 20.9782 8.78715 21.3838 9.59198 21.4785C10.3968 21.5732 11.2069 21.3493 11.843 20.8562C12.0387 20.7103 12.2147 20.5408 12.3669 20.3516",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.28ac14fb17158fc3274c28ba20d8fd13.svg";
export { ForwardRef as ReactComponent };